import { Component, ViewChild } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { EntityService } from "src/app/services/entity.service";
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-entidades-estandares",
  templateUrl: "./entidades-estandares.component.html",
  styleUrls: ["./entidades-estandares.component.css"],
})
export class EntidadesEstandaresComponent {
  displayedColumns: string[] = ["codigo", "titulo", "comite"];
  dataSource = new MatTableDataSource<any>();
  totalElements: number = 0;
  pageSize: number = 30;
  pageNumber: number = 1;
  code: string = "";
  filterTimeout: any;
  id: string = "";
  activeData: boolean;
  nameStandard: string;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  activeEror: boolean;

  constructor(
    private service: EntityService,
    private location: Location,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    window.scroll(0, 0);
    this.id = this.route.snapshot.paramMap.get("id") || "";
    this.nameStandard = localStorage.getItem("standard");
    if (this.id) {
      this.getstandard(this.id);
    } else {
      this.close();
    }
  }

  public close() {
    this.location.back();
  }

  public applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.toLowerCase().trim();
    const filteredData = this.dataSource.filteredData;
    if (filteredData.length === 0) {
      this.activeEror = true;
    } else {
      this.activeEror = false;
    }
  }

  public onPageChange(_event: PageEvent): void {
    this.getstandard(this.id);
  }

  private async getstandard(id: string): Promise<void> {
    try {
      const standard = await this.service.getEntityStandard(id);
      if (!standard || standard?.length === 0) {
        this.activeEror = true;
      } else {
        this.activeEror = false;
      }
      this.totalElements = standard.totalPages * this.pageSize;
      this.dataSource.data = standard;
      this.activeData = true;
    } catch (error) {
      this.activeData = true;
      console.error("Error al obtener cursos:", error);
    }
  }
}
